// This file is not transpiled!

// File is output manually in index.html, but vue-cli currently doesnt any way of preventing
// the bundle from also being output in <body>. Check to see if we already evaluated, and exit early
if (!window.headScriptEvaluated) {
  window.headScriptEvaluated = true

  var Head = {
    init: function() {
      var html = document.documentElement
      var platformFromLocalStorage = window.localStorage.getItem('app/platform')
      var platformFromQueryString = this.findInQueryString('platform', [
        'ios',
        'android',
        'browser'
      ])
      var platform = platformFromQueryString || platformFromLocalStorage || 'browser'
      var framedFromSessionStorage = window.sessionStorage.getItem('app/framed')
      var framedFromQueryString = this.findInQueryString('framed', ['0', '1'])
      var framed = framedFromQueryString || framedFromSessionStorage || '0'
      var callback = this.findInQueryString('callback', ['1'])

      // Replace the default 'touch' class with 'no-touch' if we don't find any touch event support
      if (!('ontouchstart' in document)) {
        html.classList.replace('touch', 'no-touch')
      }

      // Because some mobile browsers measure 100vh as the height when nav and searchbar is docked
      // and some recalculate the value when the state changes from docked to undocked and vice versa
      // it is sometimes more desireable to use the minimum height as a fixed pixel value.
      // This will prevent the browser from recalculating anything on scroll.
      // Since we are fullscreen in ios and android, there's no need to set anything here
      if (platform === 'browser') {
        html.style.setProperty('--windowInnerHeight', window.innerHeight + 'px')
      }

      // The app shell redirects to the app with the platform id in the query string as ?platform={platformid}
      // The querystring might not be present on subsequent page reloads, so we store it in client storage
      html.classList.add('platform--' + platform)

      // Figure out if we should hide the tabbar and navbar
      if (framed === '1' || callback == '1') {
        html.classList.add('window--framed')
      }
      // App can be loaded as a callback in e.g. the payment window iframe, so don't layout it
      // the normal way. Add a class to allow this
      if (callback === '1') {
        html.classList.add('window--callback')
      }

      if (platform !== platformFromLocalStorage) {
        window.localStorage.setItem('app/platform', platform)
      }
      if (framed !== framedFromSessionStorage) {
        window.sessionStorage.setItem('app/framed', framed)
      }
    },

    findInQueryString: function(params, acceptedValues) {
      var keyValuePairs = window.location.search
        .toLowerCase()
        .substring(1)
        .split('&')

      return keyValuePairs.reduce(function(acc, pair) {
        pair = pair.split('=')
        if (pair[0] === params && acceptedValues.indexOf(pair[1]) !== -1) {
          acc = pair[1]
        }
        return acc
      }, '')
    }
  }

  Head.init()
}
